export default {
	COMUM: {
		SET_EXPANDIR_MENU: 'setExpandirMenu',
		SET_LINK_ARQUIVO: 'setLinkArquivo',
		SET_MENU_AVATAR: 'setMenuAvatar',
		SET_PRODUTO: 'setProduto',
		SET_RETRAIR_MENU: 'setRetrairMenu',
		SET_ROTA_ORIGEM: 'setRotaOrigem',
		SET_USUARIO_LOGADO: 'setUsuarioLogado',
		SET_INFO_CABECALHO: 'setInfoCabecalho',
		SET_IS_PODE_ADERIR: 'setIsPodeAderir',
		ATUALIZAR_CABECALHO: 'atualizarCabecalho',
		SET_PARAMETROS_SISTEMA: 'setParametrosSistema',
		SET_LOADING_MANUAL: 'setLoadingManual',
		INCREMENT_REQUESTS_IN_PROGRESS: 'incrementRequestsInProgress',
		DECREMENT_REQUESTS_IN_PROGRESS: 'decrementRequestsInProgress',
		SET_EXECUTAR_SEM_LOADING: 'setExecutarSemLoading',

		CAMPO_ARQUIVO_NOVO: {
			SET_DOCUMENTO_SELECIONADO: 'comumDocumentosAnexosSetDocumentoSelecionado',
			LIMPAR_DOCUMENTO_SELECIONADO: 'comumDocumentosAnexosLimparDocumentoSelecionado',
			SET_DOCUMENTO_COM_ANEXOS: 'comumDocumentosAnexosSetDocumentoComAnexos',
			LIMPAR_DOCUMENTO_COM_ANEXOS: 'comumDocumentosAtaAnexosLimparDocumentoComAnexos',
			SET_ARQUIVO_TEMPORARIO: 'comumAnexoSetArquivoTemporario',
			SET_ERRO_OBRIGATORIEDADE_ARQUIVO: 'comumAnexoSetArquivoTemporarioSetErroObrigatoriedadeArquivo',
			LIMPAR_ARQUIVO_TEMPORARIO: 'comumAnexoLimparArquivoTemporario',
		},

		MODAL_ASSINATURA_FLOWBEE: {
			SET_EXIBICAO: 'setExibicaoModalAssinatura',
			SET_DOCUMENTOS: 'modalAssinaturaSetDocumentos',
			LIMPAR: 'modalAssinaturaLimpar',
		},

		CAMPO_EDITAR_NUMERO: {
			SET_NUMERO: 'comumCampoEditarNumeroSetNumero',
		},
	},
	CASAS_DECIMAIS: {
		SET_CASAS_DECIMAIS: 'setCasasDecimais',
	},
	FLOWBEE: {
		SET_HTTP_HEADER: 'flowbeeSetHttpHeader',
	},
	LOKI: {
		SET_FILES_CONFIG: 'SET_FILES_CONFIG',
		ENABLE_AUTO_SAVING: 'ENABLE_AUTO_SAVING',
		DISABLE_AUTO_SAVING: 'DISABLE_AUTO_SAVING',
		SET_AUTO_SAVED_MESSAGE: 'SET_AUTO_SAVED_MESSAGE',
		SET_SAVING_MESSAGE: 'SET_SAVING_MESSAGE',
		DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
		ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
		SET_GLOBAL_LOADING: 'setGlobalLoading',
		SET_LOADING_MESSAGE: 'setLoadingMessage',
		SET_MENU_ACTIONS: 'SET_MENU_ACTIONS',
		SET_TIMEZONE: 'setTimezone',
		SHOW_ALERT: 'showAlert',
		SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
		SET_LACUNA_LICENSE: 'SET_LACUNA_LICENSE',
	},
	ATA: {
		SET_FILTRO_LISTAGEM: 'setFiltroAtaListagem',
		SET_INFORMACOES_ATA: 'setInformacoesAta',
		RESET_INFORMACOES_ATA: 'resetInformacoesAta',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoAtaListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaAtaListagem',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroAtaListagem',
		DOCUMENTO: {
			SET_FILTRO_LISTAGEM: 'setFiltroDocumentoAtaListagem',
			SET_PAGINACAO_LISTAGEM: 'setPaginacaoDocumentoAtaListagem',
			RESETAR_PAGINA_LISTAGEM: 'resetarPaginaDocumentoAtaListagem',
			SET_ID_ATA: 'setIdAtaStateAtaDocumento',
			RESETAR_PAGINACAO_LISTAGEM: 'resetarPaginacaoDocumentoAtaListagem',
		},
	},
	ITENS: {
		SET_FILTRO_LISTAGEM: 'setFiltroItensListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoItensListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaItensListagem',
		LIMPAR_FILTRO_LISTAGEM: 'limparFiltroItensListagem',
	},
	DOCUMENTOS: {
		SET_FILTRO_LISTAGEM: 'setFiltroDocumentosListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoDocumentosListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaDocumentosListagem',
		SET_ID_ATA: 'setIdAtaStateDocumentos',
		RESETAR_PAGINACAO_LISTAGEM: 'resetarPaginacaoDocumentoListagem',
	},
	ADESAO_PUBLICA: {
		SET_FILTRO_LISTAGEM: 'setFiltroAdesaoPublicaListagem',
		SET_PAGINACAO_LISTAGEM: 'setPaginacaoAdesaoPublicaListagem',
		RESETAR_PAGINA_LISTAGEM: 'resetarPaginaAdesaoPublicaListagem',
		SET_FORM_IS_VALID: 'setAdesaoPublicaFormIsValid',
		SET_ID_SOLICITACAO_ADESAO: 'setIdSolicitacaoAdesao',
		SET_INFORMACOES_ITENS: 'setInformacoesItens',
		SET_ESTADO_FORM: 'setEstadoForm',
		SET_JUSTIFICATIVA: 'setJustificativa',
		SET_INFORMACOES_ANEXOS: 'setInformacoesAnexos',
		RESETAR_ANEXOS_LISTAGEM: 'resetarAnexosListagem',
	},
}
